import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const ComponentsLibraryPage = lazy(() => import("./ComponentsLibraryPage"));

const ComponentsLibraryPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <ComponentsLibraryPage />
    </Suspense>
  );
};

export default ComponentsLibraryPageLazy;
